<h2 class="!text-[16px] !font-bold !leading-6">
	{{ hasProfile ? "Profile" : "Setup Profile" }}
</h2>

<div class="flex flex-col gap-8 lg:flex-row" [formGroup]="profileForm">
	<div class="flex flex-col items-center gap-4">
		<div class="relative flex h-72 w-72 items-center justify-center overflow-hidden rounded bg-slate-200">
			@if (inEditMode) {
				<button
					(click)="handleOpenUpload(profilePictureRef)"
					data-size="small"
					class="aa-btn absolute right-2 top-2 h-6 px-2"
				>
					<mat-icon class="-mb-1">image</mat-icon>
					Upload
				</button>
			}
			<input
				#profilePictureRef
				(change)="handleChangeProfile($event)"
				name="image"
				type="file"
				accept="image/jpeg,image/png,image/webp,image/jpg,image/heic,image/heif,.heic,.heif"
				class="hidden"
			/>
			@if (!hasProfilePreview) {
				<div>
					<app-cbta-avatar [name]="name" [size]="288" radius="none"></app-cbta-avatar>
				</div>
			}
			@if (hasProfilePreview) {
				<img [src]="profilePreview" class="h-full w-full object-cover" />
			}
		</div>
		<div class="text-center">
			<div class="mb-0 text-xl font-medium">{{ name }}</div>
			<!-- <div class="font-bold text-red">{{getRankLabels(getProfile?.rank)}}</div> -->
		</div>
	</div>
	<div class="flex max-w-5xl flex-1 flex-col">
		<div class="text-base font-bold text-black">Profile Settings</div>
		<div id="profile-form" class="mt-4 grid grid-cols-6 gap-x-4 gap-y-2">
			<div class="col-span-6">
				<div>Name</div>
				<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
					<input formControlName="name" matInput placeholder="Name" [readonly]="true" />
				</mat-form-field>
			</div>
			<!-- <div class="col-span-2 lg:col-span-2">
      <div>Initials</div>
      <mat-form-field appearance="outline" class="w-full mt-1">
        <input
          formControlName="initials"
          matInput
          
          placeholder="Initials"
          [readonly]="hasProfile"
          />
      </mat-form-field>
    </div> -->
			<div class="col-span-6 lg:col-span-4">
				<div>Email Address</div>
				<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
					<input formControlName="email" matInput placeholder="Email" [readonly]="true" />
				</mat-form-field>
			</div>
			<div class="col-span-3 lg:col-span-2">
				<div>Staff Number</div>
				<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
					<input formControlName="staffNumber" matInput placeholder="Staff Number" [readonly]="true" />
				</mat-form-field>
			</div>
			<div class="col-span-3">
				<div>Sign Off PIN</div>
				<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
					@if (showSignOffPinMask) {
						<input
							type="password"
							[value]="signOffPinMask"
							readonly
							matInput
							aria-label="Sign Off PIN"
						/>
					} @else {
						<input
							type="{{ showHide ? 'text' : 'password' }}"
							formControlName="secretKey"
							(keypress)="customValidationService.allowOnlyNumbers($event)"
							matInput
							placeholder="Sign Off PIN"
							minlength="4"
							maxlength="6"
						/>
					}
					@if (hasSignOffPin || profileForm.get('secretKey')?.value) {
						<mat-icon (click)="toggleShowHide()" matSuffix>
							{{ showHide ? "visibility_off" : "visibility" }}
						</mat-icon>
					}
					<mat-error> Set a sign-off PIN of 4 to 6 digit. </mat-error>
				</mat-form-field>
			</div>
			<div class="col-span-1 lg:col-span-3">
				<div>AOC</div>
				<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
					<input formControlName="aoc" matInput class="w-full !px-2 uppercase" placeholder="AOC" [readonly]="true" />
				</mat-form-field>
			</div>
			<div class="col-span-3">
				<div>Organization</div>
				<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
					<input formControlName="organization" matInput placeholder="Organisation" [readonly]="true" />
				</mat-form-field>
			</div>
			<div class="col-span-2 lg:col-span-3">
				<app-cbta-autocomplete
					[autoCompleteInput]="rankControl"
					label="Rank"
					[data]="$safeNavigationMigration(rankField?.value)"
					placeholder="Rank"
					[options]="rankOptions"
					(focusOut)="saveRank($event)"
					[field]="rankField!"
					[readonly]="true"
				></app-cbta-autocomplete>
			</div>
			<div class="col-span-6 row-span-2 lg:col-span-2">
				<div>Signature</div>
				<div class="relative mb-4 mt-2 flex h-40 w-full items-center justify-center rounded border border-grey-20">
					<!-- <button
        (click)="handleOpenUpload(signatureRef)"
        data-size="small"
        class="absolute aa-btn top-2 right-2 px-2 h-6"
        [disabled]="!hasProfile">
        <mat-icon class="-mb-1">upload</mat-icon>
        Upload
      </button> -->
					@if (inEditMode) {
						<button
							(click)="showSignatureModal()"
							data-size="small"
							class="aa-btn absolute right-2 top-2 h-6 px-2"
							matTooltip="Upload a new signature"
						>
							<mat-icon class="-mb-1">draw</mat-icon>
						</button>
					}
					@if (hasSignaturePreview) {
						<img class="h-full w-auto" [src]="signaturePreview" alt="Signature" />
					}

					<input
						#signatureRef
						(change)="handleChangeSignature($event)"
						name="signature"
						type="file"
						accept="image/png"
						class="hidden"
					/>
				</div>
			</div>
			<div class="col-span-3 lg:col-span-2">
				<div>License Number</div>
				<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
					<input formControlName="licenseNumber" matInput placeholder="License Number" />
				</mat-form-field>
			</div>
			<div class="col-span-3 lg:col-span-2">
				<app-cbta-autocomplete
					[autoCompleteInput]="licenseTypeControl"
					label="License Type"
					[data]="$safeNavigationMigration(licenseTypeField?.value)"
					placeholder="License Type"
					[options]="sharedService.dropDownOptionsLicensTypes"
					(focusOut)="saveLicenseType($event)"
					[field]="licenseTypeField!"
					[clearable]="true"
				></app-cbta-autocomplete>
			</div>
			<div class="col-span-3 lg:col-span-2">
				<div>Examiner Number</div>
				<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
					<input formControlName="examinerNumber" matInput placeholder="Examiner Number" />
				</mat-form-field>
			</div>
		</div>
		<div class="profile-actions">
			@if (!inEditMode) {
				<button type="button" (click)="setEditMode(true)" class="aa-btn min-w-28">Edit Profile</button>
			}
			@if (inEditMode) {
				<div class="flex items-center gap-2">
					<button type="button" (click)="handleSubmit()" class="aa-btn min-w-28">Save</button>
					<button type="button" (click)="handleCancelSubmit()" class="aa-btn min-w-28" data-variant="secondary">
						Cancel
					</button>
				</div>
			}
		</div>
	</div>
</div>
